export function buildCalendarDisplayMetricPersistenceStorageKey(
    queryKeyPrefix: ReadonlyArray<string | null | undefined>,
): string {
    const segments = queryKeyPrefix.filter(
        (segment): segment is string => segment !== null && segment !== undefined && segment !== "",
    );
    return `ottopilot:calendar-display-metric:v1:${segments.join(":")}`;
}

export function loadCalendarDisplayMetricPersistence(storageKey: string): string | null {
    if (typeof window === "undefined") {
        return null;
    }
    try {
        const raw = window.localStorage.getItem(storageKey);
        if (raw === null || raw.trim() === "") {
            return null;
        }
        return raw;
    } catch {
        return null;
    }
}

export function saveCalendarDisplayMetricPersistence(storageKey: string, metricId: string): void {
    if (typeof window === "undefined") {
        return;
    }
    try {
        window.localStorage.setItem(storageKey, metricId);
    } catch {
        // quota / private mode
    }
}
